// Expense thresholds by tier for professional alerts
export const TIER_THRESHOLDS: Record<string, { high: number; medium: number }> = {
  HIGH_VOLUME: { high: 23, medium: 20 },
  UPPER_MID: { high: 25, medium: 22 },
  LOWER_MID: { high: 25, medium: 22 },
  BASE: { high: 25.5, medium: 22.5 },
};

// Mapping from material description to critical item name
export const CRITICAL_ITEMS_MAPPING: Record<string, string> = {
  'OIL SALAD VEG CLR NT': 'Oil Salad',
  'FALAFEL FRITTER PUCK UNCKD 1Z': 'Falafel',
  'CHIX CVP THGH BNLS SKNLS JMBO': 'Chicken Thigh',
  'CHEESE FETA GREEK': 'Feta Cheese',
  'FRIES 3/8" S/C SURECRISP': 'Fries',
  'LETTUCE ROMAINE HRTS': 'Lettuce',
  'PICKLE KOSH WHL': 'Pickles',
  'CHIX CVP TNDRLN CLPD JMBO': 'Chicken Tenderloin',
  'CHIX CVP TNDRLN CLPD JMBO RNDM': 'Chicken Tenderloin',
  'CHIX BRST BRD FLLT 5.2Z': 'Breaded Chicken Tenderloin',
  'CHIX CVP BRST BNLS SUPTRM 6Z': 'Chicken Breast',
  'CHEESE BLND MEX SHRD FINE': 'Cheddar Cheese',
  'GYRO CONE BF/LAMB HALAL': 'Gyro',
  'TOURSHI FRSH': 'Tourshi',
  'SAUCE GARL': 'Garlic Sauce',
  'PICKLE DILL SHREDDIES': 'Pickles',
  'LETTUCE ROMAINE RIBBONS': 'Lettuce',
  'HUMMUS': 'Hummus',
  'TOMATO ROMA LRG': 'Tomato',
  'FRIES 3/8" R/C LNG CRISP COATD': 'Fries',
  'CONT PLAS 32Z RECT W/LID': '32oz bowls',
  'BOWL FBR 32Z PROPLANET': '32oz bowls',
  'CHIX CVP THGH BNLS JMBO HALAL': 'Chicken Thigh',
  'GLOVE VNYL LRG PWDFR': 'Gloves',
  'GLOVE VNYL XL PWDFR': 'Gloves',
  'PICKLE SHREDDIES': 'Pickles',
  'CHIX TNDR FRTTR RTC': 'Tender',
  'TOMATO ROMA MED-XL': 'Tomato',
  'CHIX TNDRLN BRD UNCKD': 'Breaded Chicken Tenderloin',
  'CHIX TNDRLN BRD FRTTR CNTRY CAFE': 'Breaded Chicken Tenderloin',
  'PARSLEY ITAL CHPD FRSH': 'Parsley',
  'OIL SALAD CLR': 'Oil Salad',
  'CHIX TNDR BRD FC 3Z': 'Breaded Chicken Tenderloin',
  'PICKLE KOSH DILL WHL 80-100CT': 'Pickles',
  'PICKLE KOSH DILL WHL 45-55CT': 'Pickles',
  'FRIES 3/8" R/C COLOSS CRSP': 'Fries',
  'PARSLEY CURLY BUNCHED': 'Parsley',
  'MAYONNAISE HVY DUTY': 'Mayonaise',
  'CHIX CVP BRST XTRIM SNGL JMBO': 'Chicken Breast',
  'SHORTENING LIQ SOY CLR FRY ZTF': 'Fry oil',
  'CHIX TNDR BRD BTRMLK NAE': 'Tender',
  'GLOVE VNYL MED PWDFR': 'Gloves',
  'CHIX CVP BRST DBL JMBO RNDM': 'Chicken Breast',
  'TOMATO ROMA #2': 'Tomato',
  'CHIX CVP WHL LEG MT JMBO BNLS': 'Chicken Thigh',
  'CHIX CVP WHL LEG MT JMBO F2F': 'Chicken Thigh',
  'CHIX TNDRLN BRD FRTTR GLDN': 'Breaded Chicken Tenderloin',
  'TOMATO ROMA XL': 'Tomato',
  'CHIX TNDLN BRD RWA IF': 'Breaded Chicken Tenderloin',
  'LETTUCE ROMAINE CHOP': 'Lettuce',
  'PARSLEY CALIF CLND': 'Parsley',
  'PICKLE KOSH WHL 45-55CT': 'Pickles',
  'CHIX CVP BRST SKNLS JMBO 15%': 'Chicken Breast',
  'GARLIC PLD FRESH': 'Fresh Garlic',
  // Additional pickle variants
  'PICKLE KOSH DILL WHL BRRL': 'Pickles',
  'PICKLE KOSH DILL WHL 20CT': 'Pickles',
  // Additional lettuce variants
  'LETTUCE BLND ICEBERG/ROMN': 'Lettuce',
  'LETTUCE SHRD TACO 1/8CUT': 'Lettuce',
  // Additional tomato variants
  'TOMATO 5X6 XL': 'Tomato',
  'TOMATO ROMA': 'Tomato',
  // Additional glove variants
  'GLOVE NITRILE XL PWDFR BLK': 'Gloves',
  'GLOVE LTX LRG PWDFR': 'Gloves',
  // Additional parsley variants
  'PARSLEY CURLY': 'Parsley',
  // Additional mayonnaise variants
  'MAYONNAISE H/D': 'Mayonaise',
  'MAYONNAISE XHVY DUTY': 'Mayonaise',
  // Additional garlic variants
  'GARLIC WHL PLD CHIN': 'Fresh Garlic',
  // Additional fry oil variants
  'SHORTENING LIQ CANOLA CLR FRY': 'Fry oil',
  // Additional tender variants
  'CHIX TNDRLN BRD ORIG RTC': 'Breaded Chicken Tenderloin',
  'CHIX BRST TNDR FRTTR HMSTYL': 'Tender',
  'CHIX TNDR FRTTR GLDNCRSPY 2Z': 'Tender',
  'CHIX TNDR BRD HMSTYL': 'Tender',
  'CHIX TNDRLN HMSTYL BRD 2.5Z': 'Breaded Chicken Tenderloin',
  'CHIX TNDRLN CKD HMSTYL': 'Chicken Tenderloin',
  'CHIX TNDRLN BRD STHRN RTC': 'Breaded Chicken Tenderloin',
  'CHIX TNDRLN BRD': 'Breaded Chicken Tenderloin',
  'CHIX TNDR FRTTR BRD HMSTYL': 'Tender',
  'CHIX BRST TNDR FRTTR 2.13Z': 'Tender',
  'CHIX TNDRLN CLPD MED RNDM SZ CVP F2F': 'Chicken Tenderloin',
  'CHIX TNDRLN BRD FRTTR JMBO': 'Breaded Chicken Tenderloin',
  'CHIX TNDR FRTTR UNCKD': 'Tender',
  // Added 2026-11-02
  'GARLIC WHL PLD': 'Fresh Garlic',
  'FALAFEL BALL MED TOT': 'Falafel',
  'TURNIP PICKLED': 'Pickled Turnip',
  'OIL BLND SOY/POM OLV 90/10': 'Olive Oil Blend',
};



